module.exports = __webpack_public_path__ + "img/info_title.f69fa36.webp";